import { render, staticRenderFns } from "./ExtraKeyboard.vue?vue&type=template&id=0db6b7de&scoped=true&"
import script from "./ExtraKeyboard.vue?vue&type=script&lang=ts&"
export * from "./ExtraKeyboard.vue?vue&type=script&lang=ts&"
import style0 from "./ExtraKeyboard.vue?vue&type=style&index=0&id=0db6b7de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db6b7de",
  null
  
)

export default component.exports